<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">服务机构与合作客户</p>
      <p class="english-name">CLIENTS& PARTNERS</p>
      <div class="swiper-content">
        <a-carousel
          :dots="false"
          ref="swiper"
        >
          <div class="swiper-box" v-for="item in imgList" :key="item.url">
            <div class="swiper-desc ffcs-img-1"
              v-for="item in item"
              :key="item.url"
            >
              <img :src="item.url">
              <p>{{ item.name }}</p>
              <span>{{ item.ename }}</span>
            </div>
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="() => changeSwiper('prev')"><img src="../../../assets/images/icon_carousel_left.png"></p>
          <p @click="() => changeSwiper('next')"><img src="../../../assets/images/icon_carousel_right.png"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCiac,
  getCommonDetail
} from '@/api/translation.js'
import {
  getFileDetails
} from '@/api/file.js'
export default {
  name: 'client',
  data () {
    return {
      imgList: []
    }
  },
  created () {
    this._getCiac()
  },
  methods: {
    changeSwiper (name) {
      this.$refs.swiper && this.$refs.swiper[name]()
    },
    _getCiac () {
      this.imgList = JSON.parse(JSON.stringify([]))
      getCiac().then(async res => {
        const list = this._.get(res, 'data.records', [])
        for (let i of list) {
          let resI = await getCommonDetail(i.picCode, i.tenantCode)
          let img = await getFileDetails(i.appCode, i.tenantCode, [this._.get(resI, 'data.contentPicFileDtoList.0.fileCode')])
          this.imgList.push({
            name: this._.get(resI, 'data.picName', ''),
            url: this._.get(Object.values(this._.get(img, 'data')), '0.fileHttpUrl'),
            ename: this._.get(resI, 'data.contentPicFileDtoList.0.picFileUrl')
          })
        }
        this.imgList = Object.values(this.imgList).reduce((acc = [], item, index) => {
          if (index === 0) {
            acc[0] = [item]
          }
          else if ((index + 1) % 7 === 0) {
            acc.push([item])
          } else {
            acc[acc.length - 1].push(item)
          }
          return acc 
        }, [])
      })
    }
  }
}
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  position: relative;
  margin-top: 20px;
}
.box {
  width: 1140px;
  height: 550px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FAF5F5;
  position: relative;
}
.swiper-content {
  height: 360px;
  width: 1140px;
  position: relative;
  .swiper-box {
    text-align: left;
    font-size: 0px;
    .swiper-desc {
      display: inline-block;
      width: 360px;
      height: 170px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
      text-align: center;
      margin-right: 29px;
      > img {
        display: inline-block;
        width: 56px;
        height: 56px;
        margin-top: 30px;
      }
      > p {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3A3A3A;
        margin-top: 14px;
      }
      > span {
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3A3A3A;
        opacity: 0.68;
        margin-top: 10px;
      }
    }
  }
  .swiper-desc:nth-of-type(-n + 3) {
    margin-bottom: 27px;
  }
  .swiper-desc:nth-of-type(3n) {
    margin-right: 0px;
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    width: 20px;
    height: 34px;
    top: 163px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: -40px;
  }
  p:last-of-type {
    right: -36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/translationService/siderContent-04.vue